import React, { useState, useEffect } from 'react'
import { useGetIdentity } from 'react-admin'
import { CircularProgress } from '@mui/material'
import { DashboardSales } from 'src/components/pages/dashboard/DashboardSales'

export const Dashboard = () => {
  const { identity, isLoading } = useGetIdentity()
  if (isLoading) {
    return <CircularProgress />
  } else if (identity?.dashboard === 'SELLER') {
    return <DashboardSales />
  } else {
    return null
  }
}
